import React from "react";
import { Switch, Route } from "react-router-dom";
import { FETCH_REGIONS } from "../regions/RegionTypes";
import { useRouteData } from "../redux/useRouteData";
import { TeamsPanel } from "./TeamsPanel";
import { TeamForm } from "./TeamForm";

const TEAM_ROUTE_DATA = [
  FETCH_REGIONS,
];

export function TeamsPage() {
  useRouteData(TEAM_ROUTE_DATA);

  return (
    <Switch>
      <Route path="/administration/teams/:id" strict={true}>
        <TeamForm />
      </Route>
      <Route path="/administration/teams/" strict={true}>
        <TeamForm />
      </Route>
      <Route path="/administration/teams">
        <TeamsPanel />
      </Route>
    </Switch>
  );
}
